var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLoginOwallet = function SvgIconLoginOwallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-login-owallet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.25 2.844v2.7a.504.504 0 0 1-.493.506h-1.211l-3.342-3.46h4.8c.137 0 .246.112.246.254",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.655 1.69v2.9a.273.273 0 0 1-.275.28h-.974l-3.34-3.459h4.32c.151 0 .269.13.269.279",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.996 4.104v2.998a.267.267 0 0 1-.26.271h-1.912l-3.418-3.54h5.33c.143.001.26.12.26.27",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.778 14.209c-1.576 2.292-4.163 3.788-7.084 3.788C3.892 17.999 0 13.965 0 8.993 0 4.238 3.56.342 8.07.011c.038 0 .072-.005.11-.005.284.01.514.23.514.505V3.76c-2.794 0-5.057 2.346-5.057 5.238 0 2.891 2.265 5.237 5.057 5.237 2.791 0 5.056-2.346 5.056-5.237-.002.001 2.826 1.211 2.028 5.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.363 9.688a.787.787 0 0 0-.793-.69H9.28a.596.596 0 0 1-.586-.606V.513a.517.517 0 0 0-.515-.505c.032 0 .068-.006.1-.006.37-.005.57.153.621.203l7.843 8.124c.666.693.62 1.36.62 1.36",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-login-owallet_svg__b)",
    d: "M17.357 9.68a9.133 9.133 0 0 1-1.581 4.53c.798-4.004-2.03-5.21-2.03-5.21h2.82a.776.776 0 0 1 .791.68",
    opacity: 0.91
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-login-owallet_svg__b",
    x1: 15.552,
    x2: 15.552,
    y1: 14.414,
    y2: 9.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-login-owallet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgIconLoginOwallet;